import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import { messages } from './messages'

export const ONLY_DIGITS = /^\d+$/
export const VALID_LENGTHS = [6, 8]

export function validationSuite(intl: IntlShape) {
  return create((code: string) => {
    const { formatMessage: i18n } = intl
    const { validation } = messages

    omitWhen(!code.length, () => {
      test('bin', i18n(validation.invalidDigit), () => {
        enforce(code).matches(ONLY_DIGITS)
      })

      test('bin', i18n(validation.invalidLength), () => {
        enforce(code.length).inside(VALID_LENGTHS)
      })
    })
  })
}
